import styled from '@emotion/styled';

export const SettingsBody = styled('div')((p) => ({
  flex: 1
}));

export const SettingsSection = styled('div')((p) => ({
  marginBottom: p.theme.spacing(3)
}));

export const SettingsFooter = styled('div')((p) => ({
  marginTop: p.theme.spacing(6)
}));

export const SideContainer = styled('div')((p) => ({
  padding: `${p.theme.spacing(4)}px ${p.theme.spacing(3)}px`,
  height: '100%',
  width: '100%',
  overflow: 'auto',
  display: 'flex',
  flexDirection: 'column'
}));

export const MainContainer = styled(SideContainer)<{ padding?: number }>(
  (p) => ({
    padding:
      p.padding === undefined
        ? `${p.theme.spacing(1)}px ${p.theme.spacing(3)}px ${p.theme.spacing(
            4
          )}px`
        : p.theme.spacing(p.padding),
    backgroundColor: p.theme.custom.colors.gray.w100,
    borderLeft: p.theme.custom.border.standard,
    borderRight: p.theme.custom.border.standard
  })
);

export const PreviewContainer = styled(SideContainer)((p) => ({
  padding: `${p.theme.spacing(0)}px`
}));

export const PreviewHeading = styled('div')((p) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: `${p.theme.spacing(2)}px ${p.theme.spacing(3)}px`,
  backgroundColor: 'white',
  borderBottom: p.theme.custom.border.standard,
  borderLeft: p.theme.custom.border.standard,
  borderRight: p.theme.custom.border.standard
}));

export const PreviewBody = styled('div')((p) => ({
  display: 'flex',
  flex: 1,
  overflow: 'auto'
}));

export const SIDE_CONTAINER_MIN_WIDTH = 318;
export const SIDE_CONTAINER_MAX_WIDTH = 400;
export const MAIN_CONTAINER_MIN_WIDTH = 580;
export const Grid = styled('div')<{
  left?: { min: number; max: number };
  center?: { min: number };
  right?: { min: number; max: number };
}>((p) => ({
  display: 'grid',
  gridTemplateColumns: `minmax(${p.left?.min || SIDE_CONTAINER_MIN_WIDTH}px, ${
    p.left?.max || SIDE_CONTAINER_MAX_WIDTH
  }px) minmax(${p.center?.min || MAIN_CONTAINER_MIN_WIDTH}px, 1fr) minmax(${
    p.right?.min || SIDE_CONTAINER_MIN_WIDTH
  }px, ${p.right?.max || SIDE_CONTAINER_MAX_WIDTH}px)`,
  gridTemplateRows: '100%',
  height: '100%',
  width: '100%'
}));
